const hasUpgraded = ({ paymentDetails }) => {
  const lastPlanChange = paymentDetails?.last_plan_change;

  if (
    typeof lastPlanChange === "undefined" ||
    typeof lastPlanChange?.type === "undefined"
  ) {
    return false;
  }

  return lastPlanChange.type === "upgrade";
};

export default hasUpgraded;
